<div class="page__section page__section--highlight page__section--slim" *ngIf="showAppFooter">
    <div class="container">
        <div class="grid__layout">

            <div class="row">
                <div class="col">
                    <p class="u-text-align--center u-text--large u-margin-bottom--10">COHO also works great on your smaller screen</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="button__group button__group--centered">
                        <div class="button__group--item">
                            <a href="https://apps.apple.com/app/id1560659217" target="_blank" class="button button--icon-only button--cancel button--small button--app">
                                <sprite-image reference="apple-app-store" defaultImage="" alt="Download on the app store"></sprite-image>
                            </a>
                        </div>
                        <div class="button__group--item">
                            <a href="https://play.google.com/store/apps/details?id=com.houseshare.mobile" target="_blank" class="button button--icon-only button--cancel button--small button--app">
                                <sprite-image reference="google-play" defaultImage="" alt="Get it on Google Play"></sprite-image>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="footer static__footer static__footer--app">
    <div class="container">
        <div class="row logo-strap">
            <div class="col col__lg--6">
                <sprite-image reference="coho-logo-black" defaultImage="https://d19qeljo1i8r7y.cloudfront.net/web-images/logos/coho-xlarge.png" alt="COHO logo" class="footer__logo"></sprite-image>
                <h3>More than just a property management system.</h3>
                <ul class="social-links">
                    <li>
                        <a href="https://coho.life/discord" target="_blank" title="Join our Discord community">
                            <svg-icon role="img" class="icon" name="icon-discord"></svg-icon>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/channel/UCgES4D8RBD8S2-2MzBBQF2A" target="_blank" title="Watch our YouTube videos">
                            <svg-icon role="img" class="icon" name="icon-youtube"></svg-icon>
                        </a>
                    </li>
                    <li>
                        <a href="https://uk.linkedin.com/company/cohohomes" target="_blank" title="Connect with us on LinkedIn">
                            <svg-icon role="img" class="icon" name="icon-linkedin"></svg-icon>
                        </a>
                    </li>
                    <li>
                        <a href="mailto:team@coho.life" target="_blank" title="Email us">
                            <svg-icon role="img" class="icon" name="icon-mail"></svg-icon>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col col__lg--3">
                <ul class="footer__links">
                    <li>
                        <a href="{{staticWebUrl}}management/who-we-help/">Who we help</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}management/what-we-do/">What we do</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}management/pricing/">Pricing</a>
                    </li>

                </ul>
                <ul class="footer__links">
                    <li>
                        <a href="{{staticWebUrl}}management/resources/">Resources</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}management/faqs/">FAQs</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}latest-news/">News & updates</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}articles/">Longer reads</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}release-notes/">Release notes</a>
                    </li>
                </ul>
            </div>
            <div class="col col__lg--3">
                <ul class="footer__links">
                    <li>
                        <a href="{{staticWebUrl}}legal/terms-and-conditions/">Terms and conditions</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}legal/subscription-terms/">Subscription terms</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}legal/privacy-policy/">Privacy policy</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}legal/terms-of-use/">Website terms of use</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}legal/acceptable-use-policy/">Acceptable use policy</a>
                    </li>
                </ul>
                <ul class="footer__links">
                    <li>
                        <a href="{{staticWebUrl}}support/">Support</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}contact/">Contact us</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="row static__footer__copyright">
            <div class="col col__md--6">
                <p class="copyright"><copyright-text></copyright-text></p>
            </div>
            <div class="col col__md--6 only-focus">
                <ul class="focus-links">
                    <li>
                        <a href="{{staticWebUrl}}support/">Get Support</a>
                    </li>
                    <li>
                        <a href="{{staticWebUrl}}legal">The legal stuff</a>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</div>
